import { AppThunk } from "../../store/AppThunkType";
import { UserProfile } from "../../models/UserProfile";
import { getSyncGatewayDetails } from "../LoginContainer/thunks";
import database from "../../Database";
import { setSyncStatus, logOut, setArcGISToken, clearArcGISToken } from "./actions";
import IdentityManager from "@arcgis/core/identity/IdentityManager";
import Database_Local from "../../Database_Local";
import moment from "moment";

export function tryToConnect(userProfile: UserProfile): AppThunk {
    return function () {
        const { syncGatewayAddress, syncGatewayDatabase, isSsl } = getSyncGatewayDetails();

        database
            .openDatabase(
                syncGatewayAddress,
                isSsl,
                syncGatewayDatabase,
                userProfile.email,
                userProfile.syncGatewaySession
            )
            .then(() => {
                console.log("successfully connected");
            })
            .catch((error: any) => {
                console.log(error);
            });
    };
}

export function refreshReplicatorStatus(): AppThunk {
    return function (dispatch) {
        database.getReplicatorStatus().then((status) => {
            console.log(status);
            dispatch(setSyncStatus(status));
        });
    };
}

export function logout(): AppThunk {
    return function (dispatch) {
        try {
            // Close database connection
            database.closeDatabase().catch((error: any) => {
                console.warn("Error closing database during logout:", error);
            });

            // Clear ArcGIS IdentityManager credentials
            try {
                IdentityManager.destroyCredentials();
                console.log("ArcGIS credentials cleared");
            } catch (error: any) {
                console.warn("Error clearing ArcGIS credentials:", error);
            }

            // Clear all local storage values
            localStorage.clear();

            // Dispatch logout action to update Redux state (this will also clear ArcGIS token)
            dispatch(logOut());

            console.log("Logout completed successfully");
        } catch (error: any) {
            console.error("Error during logout:", error);
        }
    };
}

// Initialize ArcGIS token from storage on app start
export function initializeArcGISToken(): AppThunk {
    return function (dispatch) {
        try {
            const token = Database_Local.load("arcgis_token") as string;
            const expiry = Database_Local.load("arcgis_expires_at") as string;

            console.log("Initializing ArcGIS token from storage:", { hasToken: !!token, expiry });

            if (token && expiry && moment().isBefore(moment(expiry))) {
                console.log("Valid stored token found");
                dispatch(setArcGISToken({ value: token, expiry }));
            } else {
                console.log("No valid token found or token expired, clearing stored data");
                Database_Local.save("arcgis_token", null);
                Database_Local.save("arcgis_expires_at", null);
                dispatch(clearArcGISToken());
            }
        } catch (error: any) {
            console.error("Error initializing ArcGIS token:", error);
            dispatch(clearArcGISToken());
        }
    };
}
